import React, { FunctionComponent } from 'react';
import { useRecording } from 'features/recordings/recordingHooks';
import { DateTime } from 'luxon';
import { formatDateTime } from 'utilities/formatters';

interface RecordingDateProps {
  recordingId: string;
  cssClass?: string;
  createdAt?: string;
}

export const RecordingDate: FunctionComponent<RecordingDateProps> = (props) => {
  const recording = useRecording(props.recordingId);
  const createdAt = props.createdAt || recording?.createdAt;

  if (!createdAt) {
    return null;
  }

  return (
    <time dateTime={createdAt.toString()} className={props.cssClass}>
      {DateTime.fromISO(createdAt).toLocaleString(formatDateTime())}
    </time>
  );
};
